import { css, cx } from '@eti/styles';
import { price as priceUtil } from '@eti/utils';
import { useTranslation } from '@eti/providers';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { Stack, Inline, Text, textVariants } from '@etg/wings';
import { memo, useEffect, useRef } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const simpleStyles = css`
  max-width: 240px;
  z-index: 9999;
`;
const breakdownStyles = css`
  min-width: 240px;
  /* stylelint-disable-next-line declaration-no-important */
  padding: 16px !important;
  z-index: 9999;
`;
const inlineSpaceBetween = css`
  justify-content: space-between;
`;
const SeatTooltip = ({
  carrier,
  id,
  isDesktop,
  markup,
  price,
  seat
}) => {
  var _markup$value;
  const {
    t
  } = useTranslation();
  const tooltipRef = useRef(null);
  const formattedPrice = priceUtil.formatPrice(price);
  const normalizedMarkup = typeof markup === 'number' ? markup : (_markup$value = markup === null || markup === void 0 ? void 0 : markup.value) !== null && _markup$value !== void 0 ? _markup$value : 0;
  const markupLabel = t('Product.Markup.Label');
  const seatLabel = t('OrderDetails.Passenger.Drawer.Seat.Title');
  const tooltipPriceLabel = t('Product.SeatMap.Tooltip.Price');
  const tooltipSeatLabel = t('Product.SeatMap.Tooltip.Select');
  useEffect(() => {
    if (isDesktop) {
      return undefined;
    }
    const anchor = document.querySelector(`[data-tooltip-id='${id}']`);
    const handleOutsideInteraction = e => {
      const tooltip = tooltipRef.current;
      if (!(tooltip !== null && tooltip !== void 0 && tooltip.isOpen)) {
        return;
      }
      if (anchor !== null && anchor !== void 0 && anchor.contains(e.target)) {
        return;
      }
      tooltip.close();
    };
    window.addEventListener('touchstart', handleOutsideInteraction, {
      passive: true
    });
    window.addEventListener('click', handleOutsideInteraction);
    return () => {
      window.removeEventListener('touchstart', handleOutsideInteraction);
      window.removeEventListener('click', handleOutsideInteraction);
    };
  }, [id, isDesktop]);
  return /*#__PURE__*/_jsx(ReactTooltip, {
    ref: tooltipRef,
    className: cx('etiTooltip', carrier ? breakdownStyles : simpleStyles),
    clickable: false,
    content: carrier ? /*#__PURE__*/_jsxs(Stack, {
      spacing: 4,
      "aria-hidden": "true",
      children: [/*#__PURE__*/_jsxs(Inline, {
        alignY: "center",
        as: "p",
        className: inlineSpaceBetween,
        noWrap: true,
        children: [/*#__PURE__*/_jsx(Text, {
          variant: textVariants._14_BOLD,
          children: `${seatLabel}: ${seat}`
        }), /*#__PURE__*/_jsx(Text, {
          variant: textVariants._14_BOLD,
          children: formattedPrice
        })]
      }), /*#__PURE__*/_jsxs(Inline, {
        alignY: "center",
        as: "p",
        className: inlineSpaceBetween,
        noWrap: true,
        children: [/*#__PURE__*/_jsx(Text, {
          children: carrier.name
        }), /*#__PURE__*/_jsx(Text, {
          children: priceUtil.formatPrice(price - normalizedMarkup)
        })]
      }), /*#__PURE__*/_jsxs(Inline, {
        alignY: "center",
        as: "p",
        className: inlineSpaceBetween,
        noWrap: true,
        children: [/*#__PURE__*/_jsx(Text, {
          children: markupLabel
        }), /*#__PURE__*/_jsx(Text, {
          children: priceUtil.formatPrice(normalizedMarkup)
        })]
      })]
    }) : /*#__PURE__*/_jsxs(Stack, {
      "aria-hidden": "true",
      children: [/*#__PURE__*/_jsxs(Inline, {
        alignY: "center",
        as: "p",
        noWrap: true,
        children: [/*#__PURE__*/_jsx(Text, {
          variant: textVariants._12_BOLD,
          children: `${tooltipSeatLabel}:`
        }), /*#__PURE__*/_jsx(Text, {
          variant: textVariants._12_BOLD,
          children: seat
        })]
      }), /*#__PURE__*/_jsxs(Inline, {
        alignY: "center",
        as: "p",
        noWrap: true,
        children: [/*#__PURE__*/_jsx(Text, {
          variant: textVariants._12_BOLD,
          children: tooltipPriceLabel
        }), /*#__PURE__*/_jsx(Text, {
          variant: textVariants._12_BOLD,
          children: formattedPrice
        })]
      })]
    }),
    float: false,
    globalCloseEvents: !isDesktop ? {
      clickOutsideAnchor: false
    } : undefined,
    id: id,
    openEvents: !isDesktop ? {
      click: true
    } : undefined,
    place: "top",
    positionStrategy: "fixed"
  });
};
export default /*#__PURE__*/memo(SeatTooltip);
//# sourceMappingURL=SeatTooltip.js.map